import {
  PaStatusBucket,
  PaStatusBucketLabels,
} from "../../../../enums/paStatusBucket";

/** API filter values that differ from the UI label in `PaStatusBucketLabels`. */
const PA_STATUS_BUCKET_FILTER_VALUES: Partial<Record<PaStatusBucket, string>> =
  {
    [PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION]: "Drug Not Covered",
  };

/**
 * Builds an Outcome Class filter option using the display label in the UI and
 * the API-facing classification value in the filter payload.
 *
 * @param bucket - PA status bucket enum value
 * @return Filter option with label and API value
 */
const toPaStatusBucketFilterOption = (bucket: PaStatusBucket) => {
  const label = PaStatusBucketLabels[bucket];
  return { label, value: PA_STATUS_BUCKET_FILTER_VALUES[bucket] ?? label };
};

export const allPaStatusBucketOptions = [
  toPaStatusBucketFilterOption(PaStatusBucket.APPROVAL_ON_FILE),
  toPaStatusBucketFilterOption(PaStatusBucket.DENIAL_ON_FILE),
  toPaStatusBucketFilterOption(PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION),
  toPaStatusBucketFilterOption(PaStatusBucket.MEDICALLY_UNNECESSARY),
  toPaStatusBucketFilterOption(PaStatusBucket.STEP_THERAPY_REQUIRED),
  toPaStatusBucketFilterOption(PaStatusBucket.DONE_BY_ONSHORE),
  toPaStatusBucketFilterOption(PaStatusBucket.ASKED_CLIENT_ASSISTANCE),
  toPaStatusBucketFilterOption(PaStatusBucket.EXPIRED),
  toPaStatusBucketFilterOption(PaStatusBucket.PROCESSOR_ERROR),
  toPaStatusBucketFilterOption(PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED),
  toPaStatusBucketFilterOption(PaStatusBucket.CANCELLED_CLOSED_DUPLICATE),
  toPaStatusBucketFilterOption(PaStatusBucket.ELIGIBILITY_ERROR),
  toPaStatusBucketFilterOption(PaStatusBucket.PROGRAM_PREREQUISITE),
  toPaStatusBucketFilterOption(PaStatusBucket.NO_REVIEW_NEEDED),
  toPaStatusBucketFilterOption(PaStatusBucket.BENEFIT_LIMITATION),
  toPaStatusBucketFilterOption(PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE),
  toPaStatusBucketFilterOption(PaStatusBucket.OTHERS),
  toPaStatusBucketFilterOption(PaStatusBucket.NO_PREDEFINED_BUCKETS),
];
